import { useState } from 'react';
import { Modal } from 'src/components/Common/@electron/Modal';
import { toKebabCase } from 'src/lib/Utils/helpers';
import { ContractorCardPropsType } from '..';
import { formatPlural } from '../util/formatPlural';
import ModalResults from './ModalResults';
import Stars from './Stars';

type HeadingPropsType = Pick<
  ContractorCardPropsType,
  'tradeAllyName' | 'yearOfService' | 'stars' | 'reviews' | 'lastQualityInspection'
>;

const Heading = ({
  tradeAllyName,
  yearOfService,
  stars,
  reviews,
  lastQualityInspection,
}: HeadingPropsType) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const handleToggleModalIsOpen = () => {
    setModalIsOpen(!modalIsOpen);
  };

  const hasReviews = reviews.length > 0;

  return (
    <>
      <div data-testid={'contractor-card-heading'}>
        <div className="flex flex-nowrap justify-between min-h-76">
          <h3 className="text-teal-darker text-xl pr-4 self-end">{tradeAllyName}</h3>
          {/* hide badge icon for any year prior to 2016 */}
          {parseInt(yearOfService) > 2015 ? (
            <img
              data-testid="years-of-service-badge"
              className="h-76 w-auto"
              alt="years of service badge"
              src={`https://sc10qa-micro.duke-energy.com/_/media/apps/find-it-duke/contractor-search/img/badges/fid badge ${yearOfService}.svg`}
            />
          ) : null}
        </div>
        <div className="flex items-center">
          <Stars stars={stars} />
          {/* might need to add plural to sitecore for spanish? */}
          <button
            onClick={hasReviews ? handleToggleModalIsOpen : () => {}}
            aria-disabled={!hasReviews}
            className={`text-sm ml-16 text-teal-dark ${hasReviews ? '' : 'cursor-auto'}`}
          >{`(${reviews.length} ${formatPlural(reviews, 'Review')})`}</button>
        </div>
        {!!lastQualityInspection && (
          <div className="text-sm">Last Quality Inspection: {lastQualityInspection}</div>
        )}
      </div>
      {hasReviews && (
        <Modal
          title={`${tradeAllyName} Reviews`}
          titleVariant="text-center"
          id={`${toKebabCase(tradeAllyName)}`}
          isOpen={modalIsOpen}
          onClose={handleToggleModalIsOpen}
        >
          <ModalResults reviews={reviews} />
        </Modal>
      )}
    </>
  );
};

export default Heading;
